export enum Launch_Relax_Fantasma {
  "pt_BR" = "pt_BR",
  "es_ES" = "es_ES",
  "hu" = "hu",
}
